var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRoadsterDefault = function SvgRoadsterDefault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E242F",
    strokeWidth: 0.8,
    d: "M36.283 14.322a.885.885 0 1 1-1.77 0 .885.885 0 0 1 1.77 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E242F",
    strokeWidth: 0.774,
    d: "M37.728 14.321a2.33 2.33 0 1 1-4.66 0 2.33 2.33 0 0 1 4.66 0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E242F",
    strokeWidth: 0.8,
    d: "M13.956 14.322a.885.885 0 1 1-1.769 0 .885.885 0 0 1 1.77 0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E242F",
    strokeWidth: 0.774,
    d: "M15.4 14.321a2.33 2.33 0 1 1-4.66 0 2.33 2.33 0 0 1 4.66 0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E242F",
    strokeLinecap: "round",
    strokeWidth: 0.77,
    d: "M10.558 14.321H6.546c-.252 0-1.308-2.87-1.27-3.633.072-1.43 2.488-2.156 3.869-2.98 1.75-1.044 3.463-1.564 4.203-1.666.401-.056 1.492.39 2.148.682.341.151.715.216 1.087.184.398-.034.943-.073 1.432-.083m-2.194 7.461s11.021.035 17.143.035m5 0h3.67c.692 0 1.348-.358 1.557-1.018.289-.914.464-2.307-.444-3.595-1.233-1.75-9.06-2.654-10.499-2.806a1 1 0 0 1-.421-.141c-.914-.55-4.776-2.845-5.812-3.053q-.236-.046-.481-.086c-.525-.086-.757.613-.311.903a36 36 0 0 1 2.386 1.687c.378.294.143.876-.335.848-1.681-.1-4.548-.24-7.26-.235m0 0-.477-1.279a.79.79 0 0 0-.728-.51v0a.786.786 0 0 0-.794.785v1.004m2 0c-.443 0-1.556-.01-2 0"
  })));
};
export default SvgRoadsterDefault;